// extracted by mini-css-extract-plugin
module.exports = {"s17be3er":"s17be3er"};